<template>
  <div>
    <template v-if="varOrItemImage">
      <template v-for="img in varOrItemImage">
        <div class="my-5 item">
          <picture>
            <source :srcset="img.url" >
            <img class="img-fluid" :src="img.url" :alt="currentVariation.texts.name1" :title="currentVariation.texts.name1" />
          </picture>
        </div>
      </template>     
    </template>
  </div>
</template>


<script>
export default { 
    name: "heista-item-image", 
    inject: {
        itemId: {
            default: null
        }
    },
    computed:
    {
        currentVariation() {
            return this.$store.getters[`${this.itemId}/currentItemVariation`];
        },
        varOrItemImage() {
          if (this.currentVariation.images.variation.length > 0){
            return this.currentVariation.images.variation;
          }     
          else{
            return this.currentVariation.images.all;
          }            
        }
    }
}
</script>
